import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { Form, Row, Col, Input, Icon } from 'antd';
import { reduxForm } from 'antd-form-redux';
import { styleGutterRow } from '../../common/configConstants';

export class FormRegistro extends Component {
  static propTypes = {

  };
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleSubmit = () => {
    this.props.submitForm(this.props.form);
  }

  render() {
    const { registro, formRef, form: { getFieldDecorator } } = this.props;

    return (
      <div className="login-sap-form-registro">
        <Form
          layout="vertical"
          ref={formRef}
          onSubmit={this.handleSubmit}
        >
          <Row gutter={styleGutterRow}>
            <Col md={14}>
              <Form.Item label="Ambiente">
                {getFieldDecorator('SAP_Ambiente', {
                  initialValue: registro.SAP_Ambiente,
                  rules: [{ required: true, message: 'Campo obrigatório!' }],
                })(
                  <Input prefix={<Icon type="desktop" />} placeholder='Informe o amibiente SAP' />
                )}
              </Form.Item>
            </Col>
            <Col md={10}>
              <Form.Item label="Transação SAP">
                {getFieldDecorator('TransacaoSAP', {
                  initialValue: registro.TransacaoSAP,
                  rules: [{ required: true, message: 'Campo obrigatório!' }],
                })(
                  <Input prefix={<Icon type="code" />} placeholder='Informe a Transação SAP' />
                )}
              </Form.Item>
            </Col>
            <Col md={12}>
              <Form.Item label="Usuário">
                {getFieldDecorator('SAP_User', {
                  initialValue: registro.SAP_User,
                  rules: [{ required: true, message: 'Campo obrigatório!' }],
                })(
                  <Input prefix={<Icon type="user" />} placeholder='Informe o usuário SAP' />
                )}
              </Form.Item>
            </Col>
            <Col md={12}>
              <Form.Item label="Senha">
                {getFieldDecorator('SAP_Password', {
                  initialValue: registro.SAP_Password,
                  rules: [{ required: true, message: 'Campo obrigatório!' }],
                })(
                  <Input.Password visibilityToggle={false}  prefix={<Icon type="lock" />} placeholder='Senha SAP' />
                )}
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    loginSap: state.loginSap,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

FormRegistro = reduxForm({
  form: 'Cadastro-LoginSap',
})(FormRegistro);

FormRegistro = connect(
  mapStateToProps,
  mapDispatchToProps
)(FormRegistro);

export default FormRegistro;


// WEBPACK FOOTER //
// ./src/features/login-sap/FormRegistro.js